<template>
  <div class="containers">
    <Header></Header>
    <div class="content" id="content">
        <h2>{{detailsList.title}}</h2>
        <p v-html="detailsList.content">{{detailsList.content}}</p>
        <div class="nextRight" v-if="nextNews">
          下一篇：{{nextNews.title}}
          <img :src="nextNews.coverImg" alt="">
        </div>
        <div v-else>
        </div>
        <div class="bottomBtn">
          <el-button type="primary" :disabled="disabled" @click="previous">上一篇</el-button>
          <el-button type="primary" :disabled="disabled1" @click="next">下一篇</el-button>
        </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import { news, getLastNews, getNextNews } from '@/api/index.js'
import Footer from '../layout/commponents/Footer.vue'
import Header from '../layout/commponents/Header.vue'

export default {
  data() {
    return {
      flag: true,
      pmwidth: null,
      activerouter: null,
      logo: null,
      btn: true,
      tree: null,
      btn2: '1',
      oneTree: false,
      twotree: null,
      detailsList: [],
      detailsList1: [],
      code: 0,
      defultCode: 0,
      newslist: [],
      total: null,
      num: 1,
      pageNum: 1,
      pageSize: 50,
      lang: '',
      type: 1,
      sort: null,
      lastNews: [],
      nextNews: [],
      disabled: false,
      disabled1: false
    }
  },
  watch: {
    code() {
      return this.getLastOrNextNews()
    }
  },
  components: {
    Footer,
    Header
  },
  mounted() {
    this.code = this.$route.query.code
    this.sort = this.$route.query.sort
    this.getDetailsList()
    this.getLastOrNextNews()
  },
  methods: {
    async getDetailsList() {
      const { code } = this
      this.detailsList1 = code
      const data = await news({ id: code })
      this.detailsList = data.data.news
    },
    async getLastOrNextNews() {
      await getNextNews({ id: this.code, number: 1 }).then((res) => {
        this.nextNews = res.data[0]
        if (!res.data[0]) {
          this.disabled1 = true
        } else {
          this.disabled1 = false
        }
      })
      await getLastNews({ id: this.code, number: 1 }).then((res) => {
        this.lastNews = res.data[0]
        if (!res.data[0]) {
          this.disabled = true
        } else {
          this.disabled = false
        }
      })
    },
    next() {
      getNextNews({ id: this.code, number: 1 }).then((res) => {
        this.detailsList = res.data[0]
        this.code = res.data[0].id
      })
    },
    previous() {
      getLastNews({ id: this.code, number: 1 }).then((res) => {
        this.detailsList = res.data[0]
        this.code = res.data[0].id
      })
    }
  }
}
</script>
<style lang="less" scoped>
.content {
 width: 100%;
 background-color: #112945;
// background: linear-gradient(to right, #6495ED 0%,#112945  20%, #112945  50%,#112945  85%, #6495ED 100%);

 padding-top: 150px;
 padding-bottom: 260px;
 @media screen and (max-width: 1200px){
   height: 100vh;
 }
   h2 {
     color: #ffffff;
     text-align: center;
     font-size: 32px;
     width: 1200px;
     margin: 0 auto;
   }
   p {
     width: 1200px;
     display: block;
     margin: 0 auto;
     color: #fff;
     padding-top: 50px;
     font-size: 24px;
     font {
       display: block;
       text-align: center;
     }
     ::v-deep img {
        @media screen and (max-width: 1200px) {
          width: 1200px;
        }
      }
   }
   .bottomBtn {
     width: 1200px;
     margin: 20px auto 0;
     display: flex;
     justify-content: space-between;
   }
   .nextRight {
     color: #fff;
     position: fixed;
     right: 50px;
     top: 200px;
     width: 200px;
     img {
       width: 200px;
       height: 200px;
     }
   }
}

</style>
